import React from 'react';
import { RNLLoader } from '../../components/UI';

// the app's RNL loading spinner, used while an HR page loads its data
export default function Loader({ title = 'Loading…', subtitle = 'Fetching HR records' }) {
  return <RNLLoader title={title} subtitle={subtitle} />;
}
